<template>
    <div class="w-full container gap-8 grid grid-cols-12">
        <div class="view-h2 md:col-span-full">{{t('title')}}</div>
        <div class="w-full col-span-full grid grid-cols-12 gap-y-8 gap-x-4">
            <div class="w-full flex flex-col gap-2 col-span-full md:col-span-4 !col-start-1" v-if="featured_projects.project_1">
                <NuxtLink
                    :to="localePath(`/case/${featured_projects.project_1.data.slug}`)"
                    class="group block w-full aspect-[5/6] md-min-h-22 overflow-hidden rounded-sm"
                >
                    <ResponsiveImage
                        v-if="featured_projects.project_1.data['hero-image']"
                        :image-id="featured_projects.project_1.data['hero-image']"
                        sizes="(min-width: 768px) 33vw, 100vw"
                        class="w-full h-full object-cover object-center transition-transform duration-300 ease-in-out group-hover:scale-105"
                    />
                </NuxtLink>
                <div class="flex flex-col gap-0">
                    <div class="view-h4 uppercase">{{ textUtils.get_hyphenated_content( get_localized_value(featured_projects.project_1?.data.title)) }}</div>
                    <div class="text-dark-blue/50">{{ featured_projects.project_1?.data.credits?.['client_and_location']?.[mainStore.active_locale] }}</div>
                </div>
            </div>
            <div class="w-full flex flex-col gap-2 col-span-full md:col-span-4" v-if="featured_projects.project_2">
                <NuxtLink
                    :to="localePath(`/case/${featured_projects.project_2.data.slug}`)"
                    class="group block w-full aspect-[5/6] md-min-h-22 overflow-hidden rounded-sm"
                >
                    <ResponsiveImage
                        v-if="featured_projects.project_2.data['hero-image']"
                        :image-id="featured_projects.project_2.data['hero-image']"
                        sizes="(min-width: 768px) 33vw, 100vw"
                        class="w-full h-full object-cover object-center transition-transform duration-300 ease-in-out group-hover:scale-105"
                    />
                </NuxtLink>
                <div class="flex flex-col gap-0">
                    <div class="view-h4 uppercase">{{ textUtils.get_hyphenated_content(get_localized_value(featured_projects.project_2?.data.title)) }}</div>
                    <div class="text-dark-blue/50">{{ featured_projects.project_2?.data.credits?.['client_and_location']?.[mainStore.active_locale] }}</div>
                </div>
            </div>
            <div class="w-full flex flex-col gap-2 col-span-full md:col-span-4" v-if="featured_projects.project_3">
                <NuxtLink
                    :to="localePath(`/case/${featured_projects.project_3.data.slug}`)"
                    class="group block w-full aspect-[5/6] md-min-h-22 overflow-hidden rounded-sm"
                >
                    <ResponsiveImage
                        v-if="featured_projects.project_3.data['hero-image']"
                        :image-id="featured_projects.project_3.data['hero-image']"
                        sizes="(min-width: 768px) 33vw, 100vw"
                        class="w-full h-full object-cover object-center transition-transform duration-300 ease-in-out group-hover:scale-105"
                    />
                </NuxtLink>
                <div class="flex flex-col gap-0">
                    <div class="view-h4 uppercase">{{ textUtils.get_hyphenated_content(get_localized_value(featured_projects.project_3?.data.title)) }}</div>
                    <div class="text-dark-blue/50">{{ featured_projects.project_3?.data.credits?.['client_and_location']?.[mainStore.active_locale] }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { ApiResponse } from "#layers/cms/shared/types/ApiResponse"
import type { BucketData } from "#layers/cms/shared/types/bucketData"

const { t } = useI18n()
const mainStore = useMainStore()
const textUtils = useTextUtils()
const localePath = useLocalePath()
const { get_value: get_localized_value } = useLocalizedValue()

const {left, middle, right} = defineProps({
    left: String,
    middle: String,
    right: String
})

const featured_projects = ref<{project_1: BucketData | null, project_2: BucketData | null, project_3: BucketData | null}>({
    project_1: null,
    project_2: null,
    project_3: null
})

const retrieve_case = async (key: string) => {
    const result = await $fetch<ApiResponse>(`/api/bucketContent/website-cases/${key}?filter=title,hero-image,credits,slug`)
    if (result.success) return result.data
    else return null
}

onMounted(async () => {
    if (left) {
        featured_projects.value.project_1 = await retrieve_case(left)
    }
    if (middle) {
        featured_projects.value.project_2 = await retrieve_case(middle)
    }
    if (right) {
        featured_projects.value.project_3 = await retrieve_case(right)
    }
})

</script>

<i18n lang="yaml">
en:
  title: Related Projects
nl:
  title: Gerelateerde Projecten
</i18n>
